import { initHeroLoader } from "./modules/heroLoader.js";
import { initLocomotive } from "./modules/locomotive.js";
import { initCursor } from "./modules/cursor.js";
import { initSplitText } from "./modules/splitText.js";
import { initAnimations } from "./modules/animate.js";
import { initThemeChange } from "./modules/themeChange.js";
import { initMenuOverlay } from "./modules/menuOverlay.js";
import { initCounters } from "./modules/counters.js";
import { initHeaderScroll } from "./modules/headerScroll.js";
import { initPortfolioList } from "./modules/portfolioList.js";
import { initHeroScrollTargets, initMagneticHero } from "./modules/magneticHero.js";
import { initAccordionContent } from "./modules/accordionContent.js";
import { initStepsAccordion } from "./modules/stepsAccordion.js";
import { initImgPartsSlider } from "./modules/imgPartsSlider.js";
import { initOfferSlider } from "./modules/offerSlider.js";
import { initOfferList } from "./modules/offerList.js";
import { initContactBand } from "./modules/contactBand.js";
import { initStickyAccordionInview } from "./modules/stickyAccordionInview.js";
import { initTestimonialsSlider } from "./modules/testimonialsSlider.js";
import { initHeroCaptionSygnet } from "./modules/sygnetStroke.js";

const heroLoaderReady = initHeroLoader();

document.addEventListener("DOMContentLoaded", async () => {
  await heroLoaderReady;

  try {
    await initSplitText();
  } catch (err) {
    console.error("initSplitText failed", err);
  }

  const loco = initLocomotive(window.LocomotiveScroll);
  initAnimations(loco);
  initCursor();
  initAccordionContent(loco);
  initStepsAccordion(loco);
  initImgPartsSlider(loco);
  initOfferSlider(loco);
  initOfferList(loco);
  initContactBand(loco);

  initHeroScrollTargets();
  initMagneticHero();

  initHeaderScroll(loco);
  initThemeChange(loco);
  initMenuOverlay(loco);
  initCounters();
  initStickyAccordionInview(loco);
  initTestimonialsSlider(loco);
  initHeroCaptionSygnet();
  initPortfolioList(loco);

  if (loco) {
    const resizeLoco = () => {
      if (typeof loco.resize === "function") loco.resize();
      else if (typeof loco.update === "function") loco.update();
    };
    window.addEventListener("resize", resizeLoco);
    setTimeout(resizeLoco, 200);
  }
});
